import React, { useCallback, useState } from 'react';
import { Box, Modal, Typography, useMediaQuery } from '@material-ui/core';

import OtmLogoCloud from './OfflineOtmLogo.svg';
import theme, { useBody3Variant } from '€theme/theme';

interface OfflineNotificationInfoProps {
    handleNotificationInfoClose: Function;
}

const OfflineNotificationInfo: React.FC<OfflineNotificationInfoProps> = ({
    handleNotificationInfoClose,
}: OfflineNotificationInfoProps) => {
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const body3Classes = useBody3Variant();
    const [isOpen, setOpen] = useState<boolean>(true);

    const handleClose = useCallback(() => {
        setOpen(false);
        handleNotificationInfoClose();
    }, [handleNotificationInfoClose]);

    return (
        <Modal
            onClick={!matches ? handleClose : null}
            onClose={handleClose}
            open={isOpen}
            BackdropProps={{
                style: {
                    background: matches ? 'rgba(255, 255, 255, 0.1)' : '#000000',
                    backdropFilter: 'blur(40px)',
                    height: 'calc(100% - 28px)',
                },
            }}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            data-testid="offline-info"
        >
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                style={{ outline: 0 }}
                mb={3}
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    color="secondary.contrastText"
                    textAlign="center"
                    bgcolor="#000000"
                    justifyContent="center"
                    alignItems="center"
                    height="31.25rem"
                    width="31.25rem"
                    borderRadius="20px"
                >
                    <Box width="16.88rem" mt={{ xs: 0, sm: 9 }}>
                        <Box mb={3.5}>
                            <img
                                alt="?"
                                src={`${OtmLogoCloud}`}
                                style={{
                                    objectFit: 'contain',
                                }}
                            />
                        </Box>
                        <Typography variant="h6">You&apos;re in Offline Mode</Typography>
                        <Box mt={2}>
                            <Typography variant="body2" classes={body3Classes}>
                                Loan’s full app experience is not available while you’re offline.
                                But you can still use the app but in a limited way. Please connect
                                and try again.
                            </Typography>
                        </Box>
                        {matches && (
                            <Box mt={10}>
                                <Typography
                                    variant="h6"
                                    onClick={handleClose}
                                    style={{ cursor: 'pointer' }}
                                >
                                    Close
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

export default OfflineNotificationInfo;
